import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconChevronBottomOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M23.626 11.96a1 1 0 1 1 1.414 1.414l-8.333 8.333a1 1 0 0 1-1.414 0L6.96 13.374a1 1 0 1 1 1.414-1.415L16 19.587z" /></svg>;
export default SvgIconChevronBottomOutlined;